<template>
  <div class="document-list">
    <b-row>
      <b-col>
        <div>
          <b-table
            :busy="isBusy"
            :fields="fields"
            :items="userDocuments"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            stacked="sm"
            sort-icon-left
            @filtered="onFiltered"
            hover
            striped
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(FileName)="data">
              <a
                @click.prevent="openCertificate(data.item.FileUrl)"
                :style="linkColor"
              >{{ data.value }}</a>
            </template>
            <template #cell(EventShort)="data">
              {{ data.value.toUpperCase() }}
            </template>
            <template #cell(ChangeDateTime)="data">
              {{ formatDate(data.value) }}
            </template>
          </b-table>

        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          size="sm"
        >
        </b-pagination>
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-select
            class="w-50 float-right"
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

export default {
  name: 'List',
  props: {
    userDocuments: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      sortBy: 'ChangeDateTime',
      sortDesc: true,
      isBusy: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 11,
      pageOptions: [5, 10, 15, 25, 100],
      fields: [
        { key: 'FileName', label: this.$t('VMX.user_documents_list_document'), sortable: true },
        { key: 'EventShort', label: this.$t('VMX.user_documents_list_event'), sortable: true },
        { key: 'FileType', label: this.$t('VMX.user_documents_list_type'), sortable: true },
        { key: 'ChangeDateTime', label: this.$t('VMX.user_documents_list_last_updated'), sortable: true },
      ],
    }
  },
  mounted: async function() {
    // this.totalRows = this.userDocuments.length
    this.isBusy = false
  },
  watch: {
    userDocuments: {
      handler() {
        this.totalRows = this.userDocuments.length
      },
      deep: true,
      immediate: true,
    },
    totalRows: {
      handler() {
        this.$emit('totalRows', this.totalRows)
      },
    },
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD')
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openCertificate(url) {
      if (localStorage.getItem('isApp') === 'true') {
        this.openLink(url)
      } else {
        window.open(url, '_blank')
      }
    },
    openLink(url) {
      const message = 'html-link'
      const messageObj = {
        message,
        content: url,
      }
      const stringifiedMessageObj = JSON.stringify(messageObj)
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.cordova_iab.postMessage(
          stringifiedMessageObj,
        )
      }
    },
  },
  computed: {
    ...mapGetters({
      config: 'ModuleConfig/moduleConfig',
    }),
    linkColor() {
      let color = null
      if (this.config?.color) {
        color = `color: ${this.config.color}`
      }
      return color
    },
  },
}
</script>

<style scoped>

</style>
